const hasSpecificTranslate=(key,t)=>t(key)!==key?t(key):'';

export default hasSpecificTranslate;